import { render, staticRenderFns } from "./simplifyHisFee.vue?vue&type=template&id=0abcab4c&scoped=true"
import script from "./simplifyHisFee.vue?vue&type=script&lang=js"
export * from "./simplifyHisFee.vue?vue&type=script&lang=js"
import style0 from "./simplifyHisFee.vue?vue&type=style&index=0&id=0abcab4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abcab4c",
  null
  
)

export default component.exports